import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import Modal, {ModalBody, ModalHeader} from "../../Modal";
import ModalFooter from "../../Modal/ModalFooter";
import Button from "../../UI/Button";
import {toast} from "react-toastify";

function ModalOverlay(props) {
  const {workers} = props;
  const [workersListArray, setWorkersListArray] = useState([])
  const [workersState, setWorkersState] = useState(workers);
  // console.log(workersListArray)

  const addSelectedKeyToWorkersStateAndAddToWorkersListArray = (workerObject) => {
    //add Selected Key To Workers State
    const temp = workersState.map(v => {
      const temp = {...v}
      if (temp.id === workerObject.id) {
        temp.selected = true
      }
      return temp;
    });
    setWorkersState(temp)
    // AddToWorkersListArray
    setWorkersListArray([...workersListArray, workerObject.id])


  }
  const removeSelectedKeyFromWorkersStateAndRemoveFromWorkersListArray = (workerObject) => {
    //removeSelectedKeyFromWorkersState
    const temp = workersState.map(v => {
      const temp = {...v}
      if (temp.id === workerObject.id) {
        delete temp.selected
      }
      return temp;
    });
    setWorkersState(temp)
    // Remove From Workers List Array
    const filtered_data = workersListArray.filter((item) => {
      return (item !== workerObject.id)
    });
    setWorkersListArray(filtered_data);

  }
  const onClickEachWorkerHandler = (workerObject) => {
    // console.log(workersListArray)
    if (workersListArray.includes(workerObject.id)) {
      removeSelectedKeyFromWorkersStateAndRemoveFromWorkersListArray(workerObject)
    } else {
      addSelectedKeyToWorkersStateAndAddToWorkersListArray(workerObject)
    }


  }
  const submitHandler = () => {
    if (workersListArray.length > 0){
      props.servicesListWorkerModalHandler(workersListArray)
    }else {
      toast.error("برای خدمت کارگر انتخاب نشده است")
    }
  }

  return <>
    <Modal
      isOpen={props.isOpen}
      // modalCallback={props.workerModalHandler}
      modalCallback={props.modalCallback}
      DarkColorMode={"ON"}
    >
      <ModalHeader title={"انتخاب کارگران"}/>
      <ModalBody>
        <div className={"d-flex flex-wrap justify-content-center"}>
          {workersState.map((v, index) =>
            <div key={index}
                 className={"d-flex flex-wrap justify-content-around align-items-center rounded  m-1 cursor__pointer text-box"}
                 style={!v.selected ? {border: '2px solid transparent'} : {
                   border: '2px solid #99D7D8',
                   overflow: "hidden"
                 }}
                 onClick={() => onClickEachWorkerHandler(v)}
            >
              {v.title}
              <div style={{width: 50, height: 50}}>
                <img
                  style={{objectFit: "cover"}}
                  src={v.imgUrl} alt=""/>
              </div>
            </div>
          )}
        </div>


      </ModalBody>
      <ModalFooter>
        <Button
          color={"greenBtn"}
          onClick={submitHandler}
          className={"px-5"}>
          تایید
        </Button>
      </ModalFooter>
    </Modal>

  </>;
}

const SelectWorkerModal = (props) => {

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <ModalOverlay {...props}/>,
        document.getElementById('overlay-root')
      )}
    </React.Fragment>
  );

  // return (
  //   <>
  //     <div>
  //       مودال قراره بیاد صبور باش
  //       <button type="submit" onClick={
  //         () => workerModalHandler({
  //           id: "5",
  //           servicesTitle: "عنوان جدیده روی آیدی 5",
  //           price: "25000",
  //           workers: [55, 88, 99],
  //         })
  //       }>workerModalHandler</button>
  //     </div>
  //   </>
  // );
};

export default SelectWorkerModal;
